import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import PageNotFound from "../../../shared/presentations/PageNotFound";
import ShiftCategoryPage from "./pages/ShiftCategoryPage";
import ShiftDetailsPage from "./pages/ShiftDetailsPage";

export const TimeAndAttendanceRoutes = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={match.path + "/shift-category"} exact={true}>
        <ShiftCategoryPage />
      </Route>
      <Route path={match.path + "/shift-details"} exact={true}>
        <ShiftDetailsPage />
      </Route>
      <Redirect
        path={match.path + "/"}
        exact={true}
        to={match.path + "/shift-category"}
      ></Redirect>
      <Route>
        <PageNotFound />
      </Route>
    </Switch>
  );
};
